export const nlRcphCompanyLegalFormEntries = [
  ['bv', { labelKey: 'nl_rcph_company_legal_form_bv' }],
  ['vs', { labelKey: 'nl_rcph_company_legal_form_vs' }],
  ['nv', { labelKey: 'nl_rcph_company_legal_form_nv' }],
  ['e', { labelKey: 'nl_rcph_company_legal_form_e' }],
  ['vf', { labelKey: 'nl_rcph_company_legal_form_vf' }],
  ['st', { labelKey: 'nl_rcph_company_legal_form_st' }],
  ['ve', { labelKey: 'nl_rcph_company_legal_form_ve' }],
  ['zz', { labelKey: 'nl_rcph_company_legal_form_zz' }],
] as const

export type NlRcphCompanyLegalForm = (typeof nlRcphCompanyLegalFormEntries)[number][0]
